import { gql } from '@apollo/client';

const DELETE_SESSION = gql`
    mutation deleteSession($iltID: UUID!, $sessionID: UUID!) {
        deleteSession(iltID: $iltID, sessionID: $sessionID) {
            success
            message
        }
    }
`;

export default DELETE_SESSION;
